import { field, formatUnits, readContract, writeContractAndWait } from "../viem";
import MafiaWeeklyMissionAbi from "../../abis/MafiaWeeklyMission.json";
import config from "../../config/config";
import { CommonMissionStatus } from "../../types/WeeklyMission/CommonMissionStatus";
import { SmuggleMission } from "../../types/WeeklyMission/SmuggleMission";

const address = config.weeklyMission;
const abi = MafiaWeeklyMissionAbi;

export const startWeeklyMission = async (account: string) => {
  const data = await writeContractAndWait({
    address,
    abi,
    functionName: "startWeeklyMission",
    account,
  });
  return data;
};

export const claimWeeklyMission = async (account: string) => {
  const data = await writeContractAndWait({
    address,
    abi,
    functionName: "claimWeeklyMission",
    account,
  });
  return data;
};

export const getUserMissionStatus = async (account: string) => {
  const data: any = await readContract({
    address,
    abi,
    functionName: "getUserMissionStatus",
    args: [account],
  });

  let missionList = {
    startedAt: Number(field(data, "startedAt", 0)),
    completedAt: Number(field(data, "completedAt", 1)),
    status: Number(field(data, "status", 2)),
    maxReward: Number(formatUnits(field(data, "maxReward", 3), 18)),
    commonMissions: (field(data, "commonMissions", 4) || []).map(
      (mission: any) => {
        return {
          missionId: Number(field(mission, "missionId", 0)),
          isCompleted: field(mission, "isCompleted", 1),
        } as CommonMissionStatus;
      }
    ),
    smuggleMissions: (field(data, "smuggleMissions", 5) || []).map(
      (mission: any) => {
        return {
          messageType: field(mission, "messageType", 0),
          messageSubType: field(mission, "messageSubType", 1),
          typeId: Number(field(mission, "typeId", 2)),
          cityId: Number(field(mission, "cityId", 3)),
          isCompleted: field(mission, "isCompleted", 4),
        } as SmuggleMission;
      }
    ),
  };

  return missionList;
};
